import { render } from "./InputField.vue?vue&type=template&id=5181fde0"
import script from "./InputField.vue?vue&type=script&lang=ts"
export * from "./InputField.vue?vue&type=script&lang=ts"
script.render = render

export default script